import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'
import { useEffect } from 'react'

import { setClarity } from 'analyticActions/clarity/events'
import Offers from 'components/Offers'
import content from 'prismic-translates/page-shop.json'
import { trackSPPlacementClosed, trackSPPlacementDisplayed } from 'src/analyticActions/common/trackPaymentSnowplow'
import BenefitsSection from 'src/components/BenefitsSection'
import ShopTerms from 'src/components/ShopTerms'
import SpecialOffers from 'src/dialogs/ShopDialog/SpecialOffers'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { sweepstakeEnabledSelector } from 'store/modules/appConfig/selectors'
import { openExtraSweepDialogIfPossible } from 'store/modules/shop/actions'
import {
  getWholeNoSpecialOffersSortedByPriceAscSelector,
  offersWereAppliedSelector,
} from 'store/modules/shop/selectors'
import { getUserSubscriptionsSelector, isLoggedInSelector } from 'store/modules/user/selectors'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

function Shop() {
  const dispatch = useAppDispatch()
  const loggedIn = useAppSelector(isLoggedInSelector)
  const sweepstakeEnabled = useAppSelector(sweepstakeEnabledSelector)
  const offers = useAppSelector(getWholeNoSpecialOffersSortedByPriceAscSelector)
  const isFirstPurchaseOffer = useAppSelector(offersWereAppliedSelector)
  const userVipSubscription = useAppSelector(getUserSubscriptionsSelector)

  useEffect(() => {
    if (offers.length) {
      dispatch(openExtraSweepDialogIfPossible())
      setClarity('Purchase', 'open_store')
    }
  }, [offers.length])

  useEffect(() => {
    return () => {
      trackSPPlacementClosed({
        paymentFlow: 'coin_store',
        placementName: 'coin store',
        placementTrigger: 'navigation',
        paymentProduct: 'multiple',
      })
    }
  }, [])

  return (
    <>
      <h1 className={cx(classes.title, 'mt-typography-h4')}>{t('title')}</h1>

      <BenefitsSection />

      {sweepstakeEnabled && loggedIn && <ShopTerms />}

      <SpecialOffers snowplowPayFlow='coin_store' snowplowPlacementName='special offers section' />

      <Offers
        snowplowPayFlow='coin_store'
        snowplowPlacementName='gold packages section'
        sweepstakeEnabled={sweepstakeEnabled}
        isFirstPurchaseOffer={isFirstPurchaseOffer}
        loggedIn={loggedIn}
        offers={offers}
        userVipSubscription={userVipSubscription}
      />
    </>
  )
}

export default Shop
